import React, { memo, useContext } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';

const getCompRangeWidth = (budgetSuggestion) => {
  const {
    MinimumBudget,
    CompetitorBudgetLowerBound,
    CompetitorBudgetUpperBound,
    MaximumBudget,
  } = budgetSuggestion;

  return (((CompetitorBudgetUpperBound.DailyBudget -
    CompetitorBudgetLowerBound.DailyBudget) /
    (MaximumBudget.DailyBudget - MinimumBudget.DailyBudget)) * 100);
};

const getCompRangePosition = (budgetSuggestion) => {
  const {
    MinimumBudget,
    CompetitorBudgetLowerBound,
    MaximumBudget,
  } = budgetSuggestion;

  return (((CompetitorBudgetLowerBound.DailyBudget - MinimumBudget.DailyBudget) /
    (MaximumBudget.DailyBudget - MinimumBudget.DailyBudget)) * 100);
};

export const CompetitorSliderView = memo((props) => {
  const {
    budgetSuggestion,
    classes,
    onRenderInlineHelp,
  } = props;
  const {
    CompetitorBudgetLowerBound,
    CompetitorBudgetUpperBound,
  } = budgetSuggestion;

  const i18n = useContext(I18nContext);

  const competitorExists = !_.isEmpty(CompetitorBudgetLowerBound) && !_.isEmpty(CompetitorBudgetUpperBound);

  if (competitorExists) {
    const rawWidth = getCompRangeWidth(budgetSuggestion);
    const rawLeft = getCompRangePosition(budgetSuggestion);
    const width = `${rawWidth}%`;
    const left = `${rawLeft}%`;

    let inlineHelpStyle;
    const inlineHelpRight = rawLeft + 47; // 47%: upper(186/404)

    if (inlineHelpRight > 100) {
      // too right
      inlineHelpStyle = {
        width: '100%',
        textAlign: 'right',
      };
    } else {
      inlineHelpStyle = {
        left,
        textAlign: 'left',
      };
    }

    return (
      <React.Fragment>
        <div
          className={classes.sliderOverlay}
          key="overlay"
          style={{ width, left }}
        />
        <div
          className={`${classes.competitorHelpIndicator} help-indicator`}
          key="indicator"
          style={{ width, left }}
        />
        <div
          className={classes.competitorHelpText}
          key="help"
          style={inlineHelpStyle}
        >
          {i18n.getString(_TL_('Daily budget range for similar businesses'))}
          {onRenderInlineHelp && onRenderInlineHelp()}
        </div>
      </React.Fragment>);
  }

  return null;
});

CompetitorSliderView.propTypes = {
  budgetSuggestion: PropTypes.shape({
    MinimumBudget: PropTypes.shape({
      DailyBudget: PropTypes.number.isRequired,
    }).isRequired,
    CompetitorBudgetLowerBound: PropTypes.shape({
      DailyBudget: PropTypes.number.isRequired,
    }),
    CompetitorBudgetUpperBound: PropTypes.shape({
      DailyBudget: PropTypes.number.isRequired,
    }),
    MaximumBudget: PropTypes.shape({
      DailyBudget: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    sliderOverlay: PropTypes.string.isRequired,
    competitorHelpIndicator: PropTypes.string.isRequired,
    competitorHelpText: PropTypes.string.isRequired,
  }).isRequired,
  onRenderInlineHelp: PropTypes.func.isRequired,
};
